"use strict";
// @ts-ignore
try {
    self['workbox:precaching:6.5.3'] && _();
}
catch (e) { }
